import { AdminType, APIGet, APIUrl } from "api/protocols";
import { CancelToken } from "axios";
import { IPublicStatusBanner, StatusBannerSurface } from "../masterAdmin/statusBanner";

export async function GetActiveStatusBanners(
  params: { surface: StatusBannerSurface },
  useGlobalLoader = false,
  token?: CancelToken,
) {
  return await APIGet<IPublicStatusBanner[]>(
    APIUrl(AdminType.Guest, "/status-banner/active"),
    params,
    useGlobalLoader,
    token,
  );
}
